// reducer managing the execution state of a workflow run

function isoNow() {
  return new Date().toISOString();
}

export const ACTIONS = {
  HYDRATE: "HYDRATE",
  START: "START",
  COMPLETE_STAGE: "COMPLETE_STAGE",
  REVISIT_STAGE: "REVISIT_STAGE",
  COMPLETE_WORKFLOW: "COMPLETE_WORKFLOW",
  RESET: "RESET",
};

function createHistoryEntry(stage, visitIndex) {
  return {
    stageId: stage.id,
    stageName: stage.name,
    visitIndex,
    enteredAt: isoNow(),
    completedAt: null,
    chosenTransitionId: null,
    chosenTargetStageId: null,
    transitionLabel: null,
    taskData: {},
  };
}

export function createInitialState(workflow, startStageId) {
  const stage = workflow.stages.find((s) => s.id === startStageId);
  const now = isoNow();
  return {
    workflowId: workflow.workflowId,
    workflowName: workflow.name,
    startedAt: now,
    completedAt: null,
    status: "in_progress",
    currentStageId: stage.id,
    visitCounts: { [stage.id]: 1 },
    history: [createHistoryEntry(stage, 1)],
  };
}

export function executionReducer(state, action) {
  switch (action.type) {
    case ACTIONS.HYDRATE: {
      return action.payload || null;
    }
    case ACTIONS.START: {
      // payload: { workflow, startStageId }
      return createInitialState(
        action.payload.workflow,
        action.payload.startStageId,
      );
    }
    case ACTIONS.COMPLETE_STAGE:
    case ACTIONS.REVISIT_STAGE: {
      // payload: { workflow, transition, targetStage, taskData }
      const { workflow, transition, targetStage, taskData } = action.payload;
      const now = isoNow();
      const newState = { ...state };
      // update last history entry
      const last = newState.history[newState.history.length - 1];
      last.completedAt = now;
      last.chosenTransitionId = transition.id;
      last.chosenTargetStageId = targetStage.id;
      last.transitionLabel = transition.label || targetStage.name;
      last.taskData = taskData || {};

      // increment visit count
      const prevCount = newState.visitCounts[targetStage.id] || 0;
      newState.visitCounts[targetStage.id] = prevCount + 1;

      // add new history entry for target
      newState.history.push(
        createHistoryEntry(targetStage, newState.visitCounts[targetStage.id]),
      );
      newState.currentStageId = targetStage.id;

      return newState;
    }
    case ACTIONS.COMPLETE_WORKFLOW: {
      const now = isoNow();
      const newState = { ...state, status: "completed", completedAt: now };
      if (action.payload) {
        const { taskData, transition } = action.payload;
        const last = newState.history[newState.history.length - 1];
        if (last) {
          last.completedAt = now;
          if (taskData) last.taskData = taskData;
          if (transition) {
            last.chosenTransitionId = transition.id;
            last.transitionLabel = transition.label || "";
          }
        }
      }
      return newState;
    }
    case ACTIONS.RESET: {
      return null;
    }
    default:
      return state;
  }
}
